// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__NBApQ","rating__item":"Rating_rating__item__gmP8c","rating__starIcon":"Rating_rating__starIcon__uNZeE"};